module.exports = __webpack_public_path__ + "static/media/playButton.bc93cd14.svg";